import { useGridPrivateApiContext as useCommunityGridPrivateApiContext } from '@mui/x-data-grid/internals';
import type { GridPrivateApiPro } from '../../models/gridApiPro';

export const useGridPrivateApiContext = useCommunityGridPrivateApiContext<GridPrivateApiPro>;
